/* Achorao — Simulador FPS/Apps (v4.7)
 * - Controles separados:
 *   Juegos  -> Resolución + Calidad   (data-el="resGames","qualGames")
 *   Apps    -> Resolución             (data-el="resApps")
 * - Recalcula en vivo (sin botón)
 * - Mantiene comparativas, juegos y apps con iconos
 */
(function () {
  function init(root) {
    // Pesos promedio (kg) por componente para e-waste
const EW_WEIGHTS = {
  cpu: 0.06,   // cooler aparte, aprox
  mobo: 0.80,
  gpu: 1.10,
  ram: 0.10,   // por kit (2x8 ~)
  ssd: 0.05,
  psu: 1.60,   // promedio 550–750W
  case: 6.00   // acero + vidrio templado (medio)
};
    if (!root || root.dataset.inited === '1') return; root.dataset.inited = '1';
    const $  = (s) => root.querySelector(s);

    // ---------- Helpers ----------
    const readJSON = (role, fallback = null) => {
      const el = root.querySelector(`script[data-role="${role}"]`);
      if (!el) return fallback;
      try { return JSON.parse(el.textContent || 'null') ?? fallback; } catch { return fallback; }
    };
    const canon = s => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const safeAtob = (s) => { try { return atob(s); } catch { return ''; } };
    const tryDecodeURI = (s) => { try { return decodeURIComponent(s); } catch { return s; } };

    function decodeAchfpsParam(q) {
      let step = tryDecodeURI(q); step = tryDecodeURI(step);
      let raw = safeAtob(step);
      if (raw) { try { raw = decodeURIComponent(escape(raw)); } catch {} }
      return raw || '';
    }
    function payloadFromQS() {
      const m = location.search.match(/achfps=([^&]+)/);
      if (!m) return null;
      try { return JSON.parse(decodeAchfpsParam(m[1])); } catch { return null; }
    }
    function payloadFromSS() {
      try { const s = sessionStorage.getItem('ACH_FPS'); return s ? JSON.parse(s) : null; } catch { return null; }
    }
    const normVal = (x) => {
      if (x == null) return '';
      if (typeof x === 'string') return x;
      if (typeof x === 'object') return x.value || x.name || x._label || x.variantTitle || '';
      return String(x || '');
    };

    // ---------- Payload ----------
    const rawPayload = payloadFromQS() || payloadFromSS() || { cur:{}, up:{} };
    const payload = {
      cur: {
        cpu:  normVal(rawPayload?.cur?.cpu),
        gpu:  normVal(rawPayload?.cur?.gpu),
        mobo: normVal(rawPayload?.cur?.mobo),
        ram:  normVal(rawPayload?.cur?.ram),
        ssd:  normVal(rawPayload?.cur?.ssd),
        res:  rawPayload?.cur?.res || '1080p',
        quality: rawPayload?.cur?.quality || 'high'
      },
      up: {
        cpu:  normVal(rawPayload?.up?.cpu),
        gpu:  normVal(rawPayload?.up?.gpu),
        mobo: normVal(rawPayload?.up?.mobo),
        ram:  normVal(rawPayload?.up?.ram),
        ssd:  normVal(rawPayload?.up?.ssd)
      }
    };

    // ---------- Datasets ----------
    const BASE_CPU   = (readJSON('baseCpu')?.items) || readJSON('baseCpu') || [];
    const BASE_GPU   = readJSON('baseGpu') || [];
    const CPU_STOCK  = (readJSON('cpuStock')?.items) || [];
    const GPU_STOCK  = (readJSON('gpuStock')?.items) || [];
    const gameCovers = Object.assign({
      "Valorant":"https://assets.xboxservices.com/assets/36/b5/36b52fa8-e71b-4435-888a-cecb98d3876a.jpg?n=153142244433_GLP-Page-Hero-0_1083x1222_02.jpg",
      "Fortnite":"https://i.pinimg.com/474x/5b/52/4d/5b524dcc589c3a9f0098884c2ff21d32.jpg",
      "GTA V":"https://upload.wikimedia.org/wikipedia/en/a/a5/Grand_Theft_Auto_V.png",
      "CS2":"https://accountdb.ir/wp-content/uploads/2019/11/Counter-Strike-2-Cover-1-150x150.jpg",
      "Cyberpunk 2077":"https://cf.geekdo-images.com/hpbWvGtWJ3_JQwrJMGffYg__original/img/-lUGMnB8xsoJS0Ad1QyMPsHzvk4=/0x0/filters:format(jpeg)/pic8103339.jpg",
      "Black Myth: Wukong":"https://upload.wikimedia.org/wikipedia/en/a/a6/Black_Myth_Wukong_cover_art.jpg"
    }, readJSON('gameCovers', {}));

    const APPS = readJSON('baseApps', {
      anchor_cpu_score: 16000,
      anchor_gpu_score: 16000,
      items: [
        { name:"Premiere Pro — Export 3 min H.264", slug:"premiere_h264", category:"video", time_base_min:30, cpu_weight:0.8, gpu_weight:0.2, ram_weight:0.10, res_factor:{"720p":0.75,"1080p":1,"1440p":1.35,"2160p":2.1} },
        { name:"Premiere Pro — Export 3 min HEVC",  slug:"premiere_hevc", category:"video", time_base_min:35, cpu_weight:0.7, gpu_weight:0.3, ram_weight:0.10, res_factor:{"720p":0.8,"1080p":1,"1440p":1.4,"2160p":2.4} },
        { name:"Blender — Cycles GPU (frame medio)", slug:"blender_cycles", category:"3d", time_base_min:6,  cpu_weight:0.2, gpu_weight:0.8, ram_weight:0.05 },
        { name:"Blender — Eevee (anim 3 min)",       slug:"blender_eevee",  category:"3d", time_base_min:12, cpu_weight:0.4, gpu_weight:0.6, ram_weight:0.05 }
      ]
    });

    const appIcons = Object.assign({
      "Premiere Pro — Export 3 min H.264": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Adobe_Premiere_Pro_CC_icon.svg/64px-Adobe_Premiere_Pro_CC_icon.svg.png",
      "Premiere Pro — Export 3 min HEVC": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Adobe_Premiere_Pro_CC_icon.svg/64px-Adobe_Premiere_Pro_CC_icon.svg.png",
      "Blender — Cycles GPU (frame medio)": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Blender_logo_no_text.svg/64px-Blender_logo_no_text.svg.png",
      "Blender — Eevee (anim 3 min)": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Blender_logo_no_text.svg/64px-Blender_logo_no_text.svg.png"
    }, readJSON('appIcons', {}));

    // ---------- Controles (separados) ----------
    const resGamesSel = $('[data-el="resGames"]');
    const qualGamesSel= $('[data-el="qualGames"]');
    const resAppsSel  = $('[data-el="resApps"]');

    function readScenario() {
      try { const s = JSON.parse(sessionStorage.getItem('ACH_SCENARIO') || 'null'); if (s) return s; } catch {}
      // retro-compat: usa payload.cur para juegos y apps
      return { g:{ res: payload.cur.res || '1080p', q: payload.cur.quality || 'high' }, a:{ res: payload.cur.res || '1080p' } };
    }
    const scenario = readScenario();
    if (resGamesSel) resGamesSel.value = scenario.g?.res || '1080p';
    if (qualGamesSel)qualGamesSel.value= scenario.g?.q   || 'high';
    if (resAppsSel)  resAppsSel.value  = scenario.a?.res || (scenario.g?.res || '1080p');

    // ---------- Cabeceras ----------
    const setHTML = (sel, html) => { const el = root.querySelector(sel); if (el) el.innerHTML = html; };
    const setText  = (sel, txt)  => { const el = root.querySelector(sel); if (el) el.textContent = txt; };
    setHTML('[data-el="curCpu"]',  payload.cur.cpu || '—');
    setHTML('[data-el="curGpu"]',  payload.cur.gpu || '—');
    setHTML('[data-el="curMobo"]', payload.cur.mobo || '—');
    setHTML('[data-el="curRam"]',  payload.cur.ram || '—');
    setHTML('[data-el="curSsd"]',  payload.cur.ssd || '—');
    setHTML('[data-el="upCpu"]',   payload.up.cpu  || '—');
    setHTML('[data-el="upGpu"]',   payload.up.gpu  || '—');
    setHTML('[data-el="upRam"]',   payload.up.ram  || '—');
    setHTML('[data-el="upSsd"]',   payload.up.ssd  || '—');
    setText('[data-el="curRes"]', scenario.g?.res || '1080p');
    setText('[data-el="curQ"]',   scenario.g?.q   || 'high');

    // ---------- Scoring ----------
    const byNameLoose = (arr, name) => (arr || []).find(x => canon(x?.name) === canon(name));
    const guessGpuScore = (name)=>{
  const t=(name||'').toLowerCase();
  const map=[
    // 50-series (aprox)
    [/5090/,50000],
    [/5080/,38000],
    [/5070\s*ti|5070ti/,30000],
    [/5070/,27000],
    [/5060\s*ti|5060ti/,19000],
    [/5060/,17000],
    [/5050\s*ti|5050ti/,13000],
    [/5050/,11000],

    // 40-series
    [/4090/,42000],
    [/4080/,32000],
    [/4070\s*ti|4070ti/,28000],
    [/4070/,23000],
    [/4060\s*ti|4060ti/,18000],
    [/4060/,16000],

    // 30-series
    [/3090/,31000],
    [/3080\s*ti|3080ti/,29000],
    [/3080/,26000],
    [/3070\s*ti|3070ti/,21000],
    [/3070/,20000],
    [/3060\s*ti|3060ti/,16500],
    [/3060/,13000],
    [/3050/,10000],  // ← añadida

    // 20-series
    [/2080\s*ti|2080ti/,24000],
    [/2080/,20000],
    [/2070/,16000],
    [/2060/,12500],

    // GTX 16/10
    [/1660\s*ti|1660ti/,12000],
    [/1660\s*super/,11500],
    [/1660/,10000],
    [/1650\s*super/,8000],
    [/1650/,7000],
    [/1050\s*ti|1050ti/,4500],

    // AMD (referencial)
    [/7900\s*xtx/,36000],
    [/7900\s*xt/,32000],
    [/7800\s*xt/,24000],
    [/7700\s*xt/,20000],
    [/7600/,15000],
    [/6800\s*xt/,26000],
    [/6800/,23000],
    [/6700\s*xt/,17500],
    [/6600\s*xt/,13500],
    [/6600/,12000],
    [/6500\s*xt/,8000]
  ];
  for (const [re,s] of map){ if(re.test(t)) return s; }
  return 16000; // default si no hay match
};
    const guessCpuScore = (name)=>{ const t=(name||'').toLowerCase(); const map=[
      [/14900k/,42000],[/14700f/,34000],[/14600k|14600kf/,30000],[/14400f/,25000],[/13700f/,31000],[/13600k|13600kf/,28000],
      [/12700k|12700f/,30000],[/12400f/,19000],[/12100f/,11500],[/11700f/,22000],[/10700f/,21000],[/10600k/,18000],[/10400f/,12000],
      [/9700k|9700kf/,20000],[/9400f/,13000],[/9100f/,9000],
      [/9600x/,26000],[/7800x3d/,38000],[/7700x|7700/,30000],[/7600x|7600/,24000],
      [/5800x3d/,28000],[/5700x|5700/,23000],[/5600x|5600/,20500],[/4600g/,14500]
    ]; for(const [re,s] of map){ if(re.test(t)) return s; } return 16000; };
    const scoreCPU = name => (byNameLoose(BASE_CPU, name)?.score || byNameLoose(CPU_STOCK, name)?.score || guessCpuScore(name));
    const scoreGPU = name => (byNameLoose(BASE_GPU, name)?.score || byNameLoose(GPU_STOCK, name)?.score || guessGpuScore(name));

    const normRes = s => (s||'').toLowerCase().includes('2160')||s==='2160p'?'2160p':((s||'').toLowerCase().includes('1440')||s==='1440p'?'1440p':((s||'').toLowerCase().includes('720')||s==='720p'?'720p':'1080p'));
    const qFactor  = q => ({low:1.20, medium:1.00, high:0.85, ultra:0.70}[q] || 1);
    const cpuLimiter = s => Math.min(1, (s||8000)/16000);

    function parseRam(label){
      const t=(label||'').toLowerCase();
      const cap=(t.match(/(\d+)\s*gb/)||[])[1]|0;
      const mhz=+(t.match(/(\d{3,5})\s*mhz|(\d{3,5})/)||[])[1]||0;
      const type=/ddr5/.test(t)?'DDR5':(/ddr4/.test(t)?'DDR4':'');
      return {cap:+cap, mhz, type};
    }

    function ramGB(label, fallback){
  const n = +((label||'').match(/(\d+)\s*gb/i)||[])[1];
  return n || fallback;
}

    function ramFactor(label){
      const {cap,mhz,type}=parseRam(label);
      let f=1.0;
      if(cap && cap<16) f*=0.90;
      if(cap>=32) f*=1.03;
      if(mhz){
        const base=(type==='DDR5')?5200:3200;
        f*=Math.max(0.95, Math.min(1.06, mhz/base));
      }
      return f;
    }

    // ---------- Nombres cortos ----------
    function shortGpu(name){
      const t=(name||'').toUpperCase();
      const m = t.match(/\b(RTX|GTX|RX)\s*-?\s*(\d{3,4})(?:\s*(TI|SUPER|XT|XTX))?\b/);
      if (m) return [m[1], m[2], m[3]||''].filter(Boolean).join(' ');
      return (name||'').split('—')[0].split(',')[0].trim();
    }
    function shortCpu(name){
      const s=(name||'');
      let m = s.match(/\b(i[3579]-\d{4,5}[A-Z]{0,3}F?)\b/i);
      if (m) return m[1];
      m = s.match(/\b(?:Ryzen\s*)?([3579]\s?\d{4}[A-Z0-3]{0,3})\b/i);
      if (m) return ('Ryzen ' + m[1]).replace(/\s+/g,' ').trim();
      const base=(name||'').split('—')[0].split(',')[0].trim();
      return base.length>28 ? base.slice(0,25)+'…' : base;
    }

    // ---------- Comparativas ----------
    function renderCompare(cardEl, curName, upName, listBase, listStock, scoreFn, kind) {
      const host = cardEl?.querySelector('.ach-compare'); if (!host) return;
      host.innerHTML = '';
      const all = [...(listBase || []), ...(listStock || [])].filter(x => +x?.score > 0);
      const top = all.length ? all.reduce((a,b)=> (+a.score > +b.score ? a : b)) : null;
      const sCur = scoreFn(curName) || 0;
      const sUp  = scoreFn(upName || curName) || sCur;
      const sTop = Math.max(+top?.score || 0, sCur, sUp, 1);
      const labelFn = kind === 'cpu' ? shortCpu : shortGpu;

      const makeBar = (fullLabel, score, cls) => {
        const pctW = Math.max(2, Math.min(100, Math.round((score / sTop) * 100)));
        const wrap = document.createElement('div');
        wrap.className = `ach-bar ${cls||''}`;
        wrap.innerHTML = `
          <div class="fill" style="width:${pctW}%"></div>
          <div class="label" title="${(fullLabel||'').replace(/"/g,'&quot;')}">${labelFn(fullLabel||'')}</div>
          <div class="score">${(score||0).toLocaleString()}</div>
        `;
        host.appendChild(wrap);
        return wrap;
      };
      const curBar = makeBar(curName || '—', sCur, 'is-current');
      if (upName) {
        const upBar = makeBar(upName, sUp, 'is-up');
        if (sCur > 0) {
          const diff = sUp - sCur;
          const pct  = Math.round((diff / sCur) * 100);
          const span = document.createElement('div');
          span.className = 'pct';
          span.textContent = (pct>=0?'+':'') + pct + '%';
          upBar.appendChild(span);
        }
      }
      if (top && top.name !== upName && top.name !== curName) {
        const minor = document.createElement('div');
        minor.className = 'minor';
        minor.textContent = `Top del mercado: ${top.name} — ${(+top.score).toLocaleString()}`;
        host.appendChild(minor);
      }
      const p = document.createElement('div');
      p.className = 'note';
      if (upName && sCur>0) {
        const pct = Math.round(((sUp - sCur)/sCur)*100);
        p.textContent = `${upName} supera a ${curName || 'tu componente actual'} en ~${pct}%.`;
      } else p.textContent = 'Selecciona componentes para ver la comparación.';
      host.appendChild(p);
    }
    function drawComparatives(){
      renderCompare(root.querySelector('[data-el="cmpCpu"]'), payload.cur.cpu, payload.up.cpu, BASE_CPU, CPU_STOCK, scoreCPU, 'cpu');
      renderCompare(root.querySelector('[data-el="cmpGpu"]'), payload.cur.gpu, payload.up.gpu, BASE_GPU, GPU_STOCK, scoreGPU, 'gpu');
    }

    function drawEwaste(){
  const host = root.querySelector('[data-el="ewGrid"]');
  if (!host) return;
  host.innerHTML = '';

  // Peso base si compraras TODO el PC nuevo (sin monitor): cpu+gpu+mobo+ram+ssd+psu+case
  const baseTotal =
    EW_WEIGHTS.cpu + EW_WEIGHTS.gpu + EW_WEIGHTS.mobo +
    EW_WEIGHTS.ram + EW_WEIGHTS.ssd + EW_WEIGHTS.psu + EW_WEIGHTS.case;

  // ¿Qué piezas ha marcado para comprar? (usa payload.up)
  const buyKeys = ['cpu','gpu','mobo','ram','ssd'];
  let buyKg = 0;
  buyKeys.forEach(k => { if ((payload.up?.[k]||'').trim()) buyKg += (EW_WEIGHTS[k]||0); });

  // Ahorro vs PC nuevo completo
  const savedKg = Math.max(0, baseTotal - buyKg);
  const savedPct = baseTotal > 0 ? (savedKg / baseTotal) * 100 : 0;

  // Equivalente “CO₂ evitado” expresado en % relativo (evitamos poner factor absoluto)
  const co2Pct = savedPct;

  const cell = (k,v) => `
    <div class="card">
      <div class="k">${k}</div>
      <div class="v">${v}</div>
    </div>`;

  host.insertAdjacentHTML('beforeend', [
    cell('PC completo (e-waste)', `${baseTotal.toFixed(2)} kg`),
    cell('Si compras lo seleccionado', `${buyKg.toFixed(2)} kg`),
    cell('Ahorro de e-waste', `${savedKg.toFixed(2)} kg  (${savedPct.toFixed(0)}%)`),
    cell('CO₂ evitado (relativo)', `${co2Pct.toFixed(0)}%`)
  ].join(''));
}

    // ---------- Juegos ----------
    function ensureGamesGrid() {
      let grid = root.querySelector('.fps .grid');
      if (!grid) { grid = document.createElement('div'); grid.className = 'grid'; root.querySelector('.fps').appendChild(grid); }
      grid.innerHTML = `
        <div class="hdr">Juego</div>
        <div class="hdr mono">FPS (PC actual)</div>
        <div class="hdr mono">FPS (PC nueva)</div>
        <div class="hdr mono">Δ FPS ganados</div>
        <div class="hdr mono">% de mejora</div>
      `;
      return grid;
    }
    const ANCHOR = (BASE_GPU.find(g=>g.fps && g.score) || {
      score:16000,
      fps:{
        "1080p":{"Valorant":420,"Fortnite":170,"GTA V":140,"CS2":520,"Cyberpunk 2077":85,"Black Myth: Wukong":95},
        "1440p":{"Valorant":330,"Fortnite":130,"GTA V":110,"CS2":400,"Cyberpunk 2077":62,"Black Myth: Wukong":72},
        "2160p":{"Valorant":190,"Fortnite": 90,"GTA V": 75,"CS2":250,"Cyberpunk 2077":38,"Black Myth: Wukong":45}
      }
    });
    const tableFromScore = (score) => {
      const gamma=0.95, ratio=Math.pow(score/(ANCHOR.score||16000), gamma);
      const mk=rk=>{ const out={}, b=ANCHOR.fps[rk]||ANCHOR.fps['1080p']||{}; for(const g in b) out[g]=b[g]*ratio; return out; };
      return {"1080p":mk('1080p'), "1440p":mk('1440p'), "2160p":mk('2160p')};
    };
    function drawFps() {
      const grid = ensureGamesGrid(); if (!grid) return;
      const resK = normRes(resGamesSel?.value || '1080p');
      const qf   = qFactor(qualGamesSel?.value || 'high');

      const scCPU_cur = scoreCPU(payload.cur.cpu) || 8000;
      const scCPU_up  = scoreCPU(payload.up.cpu || payload.cur.cpu) || scCPU_cur;
      const scGPU_cur = scoreGPU(payload.cur.gpu) || 16000;
      const scGPU_up  = scoreGPU(payload.up.gpu || payload.cur.gpu) || scGPU_cur;

      const ramF_cur = ramFactor(payload.cur.ram);
      const ramF_up  = ramFactor(payload.up.ram || payload.cur.ram);

      const tblCur = byNameLoose(BASE_GPU, payload.cur.gpu)?.fps || tableFromScore(scGPU_cur);
      const tblUp  = byNameLoose(BASE_GPU, payload.up.gpu)?.fps  || tableFromScore(scGPU_up);

      const games = Object.keys(ANCHOR.fps[resK] || {});
      games.forEach(game => {
        const baseCur = (tblCur[resK] && tblCur[resK][game]) ? tblCur[resK][game] : 1;
        const baseUp  = (tblUp [resK] && tblUp [resK][game]) ? tblUp [resK][game] : 1;
        const fpsCur = Math.max(1, Math.round(baseCur*qf*(0.7+0.3*cpuLimiter(scCPU_cur))*ramF_cur));
        const fpsUp  = Math.max(1, Math.round(baseUp *qf*(0.7+0.3*cpuLimiter(scCPU_up ))*ramF_up ));
        const d = fpsUp - fpsCur;
        const pct = (d/Math.max(1,fpsCur))*100;
        const img = gameCovers[game] ? `<img src="${gameCovers[game]}" alt="${game}">` : '';
        grid.insertAdjacentHTML('beforeend', `
          <div class="c game">${img}<span>${game}</span></div>
          <div class="c mono">${fpsCur}</div>
          <div class="c mono">${fpsUp}</div>
          <div class="c mono">${d>=0?'+':''}${d}</div>
          <div class="c mono">${Math.round(pct)}%</div>
        `);
      });
    }

    // ---------- APPS ----------
    function mkAppsGrid() {
      const grid = document.createElement('div');
      grid.className = 'apps-grid';
      grid.innerHTML = `
        <div class="hdr">Tarea</div>
        <div class="hdr mono">Tiempo actual</div>
        <div class="hdr mono">Tiempo nuevo</div>
        <div class="hdr mono">Δ tiempo ganado</div>
        <div class="hdr mono">% de mejora</div>
      `;
      return grid;
    }
    const fmtMin = m => (!isFinite(m)||m<=0) ? '—' : (()=>{ const mm=Math.round(m); const h=Math.floor(mm/60), r=mm%60; return h?`${h}h ${r}m`:`${r} min`; })();

    function drawApps() {
      const host = root.querySelector('.apps'); if (!host) return;
      // limpia
      host.querySelectorAll('.apps-grid, h4.__group').forEach(n => n.remove());

      const resK = normRes(resAppsSel?.value || '1080p');
      const anchorCPU = APPS.anchor_cpu_score || 16000;
      const anchorGPU = APPS.anchor_gpu_score || 16000;

      const scCPU_cur = scoreCPU(payload.cur.cpu) || anchorCPU;
      const scCPU_up  = scoreCPU(payload.up.cpu || payload.cur.cpu) || scCPU_cur;
      const scGPU_cur = scoreGPU(payload.cur.gpu) || anchorGPU;
      const scGPU_up  = scoreGPU(payload.up.gpu || payload.cur.gpu) || scGPU_cur;

      const rf_cur = ramFactor(payload.cur.ram);
      const rf_up  = ramFactor(payload.up.ram || payload.cur.ram);

      const groups = [
        { key:'video', title:'Exportación de video (Premiere Pro)' },
        { key:'3d',    title:'Renderizado 3D (Blender)' }
      ];

      groups.forEach(g => {
        const items = (APPS.items||[]).filter(a => a.category === g.key);
        if (!items.length) return;
        const title = document.createElement('h4');
        title.className='__group';
        title.textContent = g.title;
        host.appendChild(title);

        const grid = mkAppsGrid();
        host.appendChild(grid);

        items.forEach(app => {
          const base=+app.time_base_min||0, cw=+app.cpu_weight||0, gw=+app.gpu_weight||0, rw=+app.ram_weight||0.08;
          const resF = (app.category==='video' && app.res_factor) ? (app.res_factor[resK]||1) : 1;
          const rest = Math.max(0, 1-(cw+gw+rw));
          const curTime = base*resF*( cw*(anchorCPU/scCPU_cur) + gw*(anchorGPU/scGPU_cur) + rw*(1/rf_cur) + rest*1 );
          const upTime  = base*resF*( cw*(anchorCPU/scCPU_up ) + gw*(anchorGPU/scCPU_up ) + rw*(1/rf_up ) + rest*1 );
          const dMin = upTime - curTime;
          const pct  = curTime>0 ? ((curTime - upTime)/curTime)*100 : 0;
          const iconUrl = appIcons[app.name];
          const icon = iconUrl
          ? `<img class="app-icon" src="${iconUrl}" alt=""
              onerror="this.onerror=null;this.src='https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/blender.svg';">`
            : '';
          grid.insertAdjacentHTML('beforeend', `
            <div class="c task">${icon}<span>${app.name}</span></div>
            <div class="c mono">${fmtMin(curTime)}</div>
            <div class="c mono">${fmtMin(upTime)}</div>
            <div class="c mono">${dMin>=0?'-':''}${fmtMin(Math.abs(dMin))}</div>
            <div class="c mono">${Math.round(pct)}%</div>
          `);
        });
      });
    }
    function drawEwaste(){
  const host = root.querySelector('[data-el="ewGrid"]');
  if (!host) return;
  host.innerHTML = '';

  const baseTotal =
    EW_WEIGHTS.cpu + EW_WEIGHTS.gpu + EW_WEIGHTS.mobo +
    EW_WEIGHTS.ram + EW_WEIGHTS.ssd + EW_WEIGHTS.psu + EW_WEIGHTS.case;

  const buyKeys = ['cpu','gpu','mobo','ram','ssd'];
  let buyKg = 0;
  buyKeys.forEach(k => { if ((payload.up?.[k]||'').trim()) buyKg += (EW_WEIGHTS[k]||0); });

  const savedKg  = Math.max(0, baseTotal - buyKg);
  const savedPct = baseTotal > 0 ? (savedKg / baseTotal) * 100 : 0;
  const co2Pct   = savedPct;

  const cell = (k,v) => `
    <div class="card">
      <div class="k">${k}</div>
      <div class="v">${v}</div>
    </div>`;

  host.insertAdjacentHTML('beforeend', [
    cell('PC completo (e-waste)', `${baseTotal.toFixed(2)} kg`),
    cell('Si compras lo seleccionado', `${buyKg.toFixed(2)} kg`),
    cell('Ahorro de e-waste', `${savedKg.toFixed(2)} kg (${savedPct.toFixed(0)}%)`),
    cell('CO₂ evitado (relativo)', `${co2Pct.toFixed(0)}%`)
  ].join(''));
}
function drawOffice(){
  const host = root.querySelector('[data-el="officeGrid"]');
  if(!host) return;
  host.innerHTML = `
    <div class="hdr">Tarea</div>
    <div class="hdr mono">Capacidad actual</div>
    <div class="hdr mono">Capacidad nueva</div>
    <div class="hdr mono">Mejora</div>
    <div class="hdr mono">% de mejora</div>
  `;

  // RAM estimada
  const curRam = ramGB(payload.cur.ram, 8);
  const upRam  = ramGB(payload.up.ram || payload.cur.ram, 16);

  // reserva SO
  const sys = 3; // GB
  const availCur = Math.max(0, curRam - sys);
  const availUp  = Math.max(0, upRam  - sys);

  // supuestos de consumo
  const tabGB   = 0.35; // pestaña Chrome
  const excelGB = 0.60; // workbook “medio”
  const ytGB    = 0.70; // 1080p + segundo monitor (buffers/comp apps)

  // métricas
  const tabsCur = Math.max(1, Math.floor(availCur / tabGB));
  const tabsUp  = Math.max(1, Math.floor(availUp  / tabGB));

  const xlsCur  = Math.max(1, Math.floor(availCur / excelGB));
  const xlsUp   = Math.max(1, Math.floor(availUp  / excelGB));

  const ytCurOK = availCur >= ytGB;
  const ytUpOK  = availUp  >= ytGB;

  const row = (icon, label, cur, up) => {
    const d   = up - cur;
    const pct = Math.round((d / Math.max(1,cur)) * 100);
    host.insertAdjacentHTML('beforeend', `
      <div class="c task">
        <img class="app-icon" src="${icon}" alt="" />
        <span>${label}</span>
      </div>
      <div class="c mono">${cur}</div>
      <div class="c mono">${up}</div>
      <div class="c mono">${d>=0?'+':''}${d}</div>
      <div class="c mono">${pct}%</div>
    `);
  };

  // filas
  row('https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Google_Chrome_icon_%28February_2022%29.svg/960px-Google_Chrome_icon_%28February_2022%29.svg.png',
      'Pestañas de Chrome simultáneas', tabsCur, tabsUp);

  row('https://cdn.worldvectorlogo.com/logos/excel-4.svg',
      'Libros de Excel/Sheets “medios” abiertos', xlsCur, xlsUp);

}

    // ---------- Guardar preferencias de controles ----------
    function persistScenario(){
      const s = {
        g:{ res: resGamesSel?.value || '1080p', q: qualGamesSel?.value || 'high' },
        a:{ res: resAppsSel?.value || '1080p' }
      };
      sessionStorage.setItem('ACH_SCENARIO', JSON.stringify(s));
      // refleja en cabecera MI PC
      setText('[data-el="curRes"]', s.g.res);
      setText('[data-el="curQ"]',   s.g.q);
    }

    function recalcAll(){
  persistScenario();
  drawComparatives();
  drawFps();
  drawApps();
  drawOffice();
  drawEwaste();
}

    // Eventos (en vivo)
    resGamesSel  && resGamesSel  .addEventListener('change', recalcAll);
    qualGamesSel && qualGamesSel .addEventListener('change', recalcAll);
    resAppsSel   && resAppsSel   .addEventListener('change', recalcAll);

    // WhatsApp — soporta 1+ botones con data-el="quoteBtn"
const waBtns = Array.from(document.querySelectorAll('[data-el="quoteBtn"]'));
waBtns.forEach((btn) => {
  btn.addEventListener('click', () => {
    // usa los mismos selects que ya existen en este archivo:
    const s = {
      res: resGamesSel?.value || '1080p',
      q:   qualGamesSel?.value || 'high'
    };
    const p = payload; // el payload que ya construyes al cargar

    const lines = [
      `*Mi PC:* CPU ${p.cur.cpu || '-'} | GPU ${p.cur.gpu || '-'} | MOBO ${p.cur.mobo || '-'} | RAM ${p.cur.ram || '-'} | SSD ${p.cur.ssd || '-'}`,
      `*Nueva PC:* CPU ${p.up.cpu || '-'} | GPU ${p.up.gpu || '-'} | MOBO ${p.up.mobo || '-'} | RAM ${p.up.ram || '-'} | SSD ${p.up.ssd || '-'}`,
      `Escenario (juegos): ${s.res} · ${s.q}`,
      `¿Me cotizas estos componentes?`
    ];

    try {
      const u = new URL(btn.getAttribute('href'));
      u.searchParams.set('text', lines.join('\n')); // sin encodeURIComponent extra
      btn.setAttribute('href', u.toString());
    } catch {
      const href = btn.getAttribute('href') || '#';
      btn.setAttribute(
        'href',
        href + (href.includes('?') ? '&' : '?') + 'text=' + encodeURIComponent(lines.join('\n'))
      );
    }
  });
});

    // Primera pasada
    recalcAll();
  }

  function boot(){ document.querySelectorAll('.ach-fps').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (e) => { const r = e.target?.querySelector?.('.ach-fps'); if (r) init(r); });
})();
